const TEST_AD_CLIENT = 'ca-pub-3940256099942544'
const MOCK_SLOT_PREFIX = 'mock-'

function getAdValue(ad, key) {
	if (!ad || typeof ad !== 'object') {
		return ''
	}
	return ad[key] || ''
}

export function getAdClient(ad) {
	return getAdValue(ad, 'data-ad-client')
}

export function getAdSlot(ad) {
	return getAdValue(ad, 'data-ad-slot')
}

export function isPlaceholderAd(ad) {
	const adClient = getAdClient(ad)
	const adSlot = getAdSlot(ad)
	return Boolean(adClient && adSlot && (adClient === TEST_AD_CLIENT || adSlot.indexOf(MOCK_SLOT_PREFIX) === 0))
}

export function hasRenderableAd(ad) {
	const adClient = getAdClient(ad)
	const adSlot = getAdSlot(ad)
	return Boolean(adClient && adSlot && !isPlaceholderAd(ad))
}

export function getRenderableAd(ad) {
	return hasRenderableAd(ad) ? ad : null
}

export function createAdVariantOrNull(baseAd, suffix) {
	if (!hasRenderableAd(baseAd) || !suffix) {
		return null
	}
	return {
		...baseAd,
		'data-ad-slot': `${getAdSlot(baseAd)}-${suffix}`,
	}
}
